import Loader from "../../components/loader";
import { useAppLoaderSelector } from "../../store/selectors/loaderSelector";

function AppLoader() {
    const show = useAppLoaderSelector();

    return show ? (
        <div className="loader">
            <div className="fixed h-screen w-screen bg-white bg-opacity-50 z-[9999] flex justify-center items-center">
                <Loader />
            </div>
        </div>
    ) : null;
}

export default AppLoader;
